<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
import { wxConfigInitThrottle } from "@/assets/js/wxShare.js";

export default {
  name: "App",

  watch: {
    "$route.path": {
      handler() {
        wxConfigInitThrottle();
      },
      immediate: true,
    },
    // 目前仅有AI识别检测页面生效
    "$route.query": {
      handler() {
        wxConfigInitThrottle();
      },
    },
  },
};
</script>

<style lang="scss">
@import "./assets/css/varibles.scss";
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  /* color: #2c3e50;
  margin-top: 60px; */
  margin-bottom: 30px;
}
img,
video {
  max-width: 100%;
}
@media screen and (min-width: $maxWidth) {
  #app {
    width: $maxWidth;
    margin: 0 auto;
  }
}
</style>
